import React, { useMemo } from 'react'
import { Text, View } from '../other/html'
import { COLORS } from '../../theme'
import { formatPrice } from '../../helpers/formatPrice'
import { useTranslation } from 'react-i18next'

interface Props {
  highestBet: number
  yourHighestBet: number | null
  tilesView?: boolean
}

type ComponentVariant = 'noBets' | 'myBetIsHighest' | 'otherHighest' | 'notBetted'
interface VariantProperties {
  headLine: string
  color: keyof typeof COLORS
  offer: string
}

type VariantDictionary = Record<ComponentVariant, VariantProperties>

const AuctionPrice = ({ highestBet, yourHighestBet, tilesView = false }: Props): JSX.Element => {
  const { t } = useTranslation()
  const variant = useMemo(() => {
    const offerWithBets = typeof highestBet === 'number' && highestBet > 0
    let variantKey: ComponentVariant = 'noBets'
    if (offerWithBets) {
      if (yourHighestBet === highestBet) {
        variantKey = 'myBetIsHighest'
      }
      if (typeof yourHighestBet === 'number' && yourHighestBet > 0 && highestBet > yourHighestBet) {
        variantKey = 'otherHighest'
      }
      if (yourHighestBet === null) {
        variantKey = 'notBetted'
      }
    }
    const dictionary: VariantDictionary = {
      noBets: {
        headLine: tilesView ? t('first_offer_short') : t('first_offer'),
        color: 'grey',
        offer: '-'
      },
      notBetted: {
        headLine: tilesView ? t('highest_offer_short') : t('highest_offer'),
        color: 'yellow',
        offer: formatPrice(highestBet)
      },
      otherHighest: {
        headLine: tilesView ? t('highest_offer_short') : t('highest_offer'),
        color: 'errorRed',
        offer: formatPrice(highestBet)
      },
      myBetIsHighest: {
        headLine: t('your_offer'),
        color: 'groupBlue',
        offer: formatPrice(highestBet)
      }
    }
    return dictionary[variantKey]
  }, [t, highestBet, yourHighestBet, tilesView])

  return (
    <View className="flex flex-col items-center gap-1">
      <Text fontWeight="SemiBold" center={true}>
        {variant.headLine}
      </Text>
      <View className={`flex align-bottom gap-1 ${tilesView ? 'flex-row' : 'flex-col'}`}>
        <Text fontWeight="Bold" color={variant.color} fontSize="xl">
          {variant.offer}
        </Text>
        <Text
          fontWeight={tilesView ? 'Bold' : 'Medium'}
          color={variant.color}
          className={tilesView ? 'text-xl' : 'text-m'}
          center={true}>
          EUR
        </Text>
      </View>
    </View>
  )
}

export default AuctionPrice
